import React, { useState } from 'react';

// Material UI
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

// FontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilePdf, faFileExcel, faFileCsv, faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import { Box, Divider, List, ListItem, ListItemText, Modal, Paper, Typography } from '@mui/material';
import { InterpretationInstructions } from './InterpretationInstructions';
import { OutputSectionsTable } from './OutputSectionsTable';

// Import our store

// API

// Types
interface Props {
  csv_data?: string
  file_name?: string
}

const DownloadResults = ({
  csv_data,
  file_name = "siRNA"
}: Props) => {

  const [howToInterpretOpen, setHowToInterpretOpen] = useState<boolean>(false);

  const renderDownloadCSV = () => {
    return <>
      {/* CSV */}
      {csv_data ?
        <Tooltip title="Download CSV" arrow>
          <a href={"data:text/csv;charset=utf-8," + encodeURIComponent(csv_data)} download={`${file_name}.csv`} target='_blank'>
            <IconButton aria-label="CSV" size="medium">
              <FontAwesomeIcon icon={faFileCsv} size="xl"/>
            </IconButton>
          </a>
        </Tooltip>
      :<></>}
    </>
  }

  const renderInterpretInstructions = () => {
    return <>
      <Tooltip title="How to interpret results" arrow>
        <IconButton aria-label="PDF" size="medium" onClick={() => {
          setHowToInterpretOpen(true);
        }}>
          <FontAwesomeIcon icon={faQuestionCircle} size="xl"/>
        </IconButton>
      </Tooltip>
    </>
  }

  return (
    <>
      <Modal open={howToInterpretOpen} onClose={() => {
        setHowToInterpretOpen(false);
      }}>
         <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "80%",
              maxWidth: 900,
              maxHeight: "80vh",
              overflowY: "auto",
              outline: "none",
            }}
          >
            <Paper elevation={6} sx={{ p: 3 }}>
              <Stack spacing={2}>
                <Typography variant="h5" fontWeight={700} textAlign={"center"}>
                  siRNA Prediction Algorithm Output File Info
                </Typography>

                <Typography variant="body1">
                  Includes newest scoring with machine learning model.
                </Typography>

                <Typography variant="body2" color="text.secondary">
                  NOTE: currently the NCBI <i>Macaca mulatta</i> database is limited.
                  If you want cross-reactive sequences, use ENSEMBL BLAST for a more
                  thorough search (and likely more hits):
                  <br />
                  <a
                    href="https://uswest.ensembl.org/Multi/Tools/Blast"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    https://uswest.ensembl.org/Multi/Tools/Blast
                  </a>
                </Typography>

                <Divider />

                <InterpretationInstructions />
                <OutputSectionsTable />

                <Typography variant="body2" color="text.secondary">
                  Last Updated: Nov-01-2025
                </Typography>
              </Stack>
            </Paper>
          </Box>
      </Modal>
      <Stack direction="row" alignItems="center" spacing={1}>
        {renderInterpretInstructions()}
        {renderDownloadCSV()}
      </Stack>
    </>
  );
};

export default DownloadResults;